import { Environment } from './environment.interface';

export const isProd = (env: Environment): env is Environment & { mode: 'prod' } => env.mode === 'prod';

export const isDemo = (env: Environment): env is Environment & { mode: 'demo' } => env.mode === 'demo';

export const isDevelop = (env: Environment): env is Environment & { mode: 'develop' } => env.mode === 'develop';

export const isLocal = (env: Environment): env is Environment & { mode: 'local' } => env.mode === 'local';

export const isTest = (env: Environment): env is Environment & { mode: 'test' } => env.mode === 'test';
